import { Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Home from './pages/Home';
import Product from './pages/Product';
import VirtualWalkthrough from './pages/VirtualWalkthrough';
import Renderings from './pages/Renderings';
import Pricing from './pages/Pricing';
import Contact from './pages/Contact';
import ArtRoom from './pages/tours/ArtRoom';
import Moulin from './pages/tours/Moulin';
import Resources from './pages/Resources';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Copyright from './pages/Copyright';
import NotFound from './pages/NotFound';
import { usePageTracking } from './hooks/usePageTracking';

function App() {
  usePageTracking();

  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="product" element={<Product />} />
        <Route path="virtual-walkthrough-services" element={<VirtualWalkthrough />} />
        <Route path="3d-rendering-services" element={<Renderings />} />
        <Route path="pricing" element={<Pricing />} />
        <Route path="contact" element={<Contact />} />
        <Route path="tours/art-room" element={<ArtRoom />} />
        <Route path="tours/moulin" element={<Moulin />} />
        <Route path="opportunity-hub" element={<Resources />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="copyright" element={<Copyright />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;